(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initCarousels();
    initNavToggle();
    initProductVariants();
    initProductThumbs();
  });

  function initCarousels() {
    document.querySelectorAll('[data-carousel-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('data-carousel-prev'));
        if (target) target.scrollBy({ left: -260, behavior: 'smooth' });
      });
    });
    document.querySelectorAll('[data-carousel-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('data-carousel-next'));
        if (target) target.scrollBy({ left: 260, behavior: 'smooth' });
      });
    });
  }

  function initNavToggle() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.getElementById('HeaderNav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function initProductThumbs() {
    var mainImage = document.getElementById('ProductMainImage');
    document.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImage) return;
        var full = thumb.getAttribute('data-full');
        if (full) mainImage.src = full;
      });
    });
  }

  function initProductVariants() {
    var variantInput = document.getElementById('ProductVariantId');
    var selects = document.querySelectorAll('.pdp__select');
    if (!variantInput || selects.length === 0) return;

    var variants = [];
    try {
      variants = JSON.parse(variantInput.getAttribute('data-variants'));
    } catch (e) {
      return;
    }

    function currentSelection() {
      var values = [];
      selects.forEach(function (select) {
        values[parseInt(select.getAttribute('data-option-index'), 10)] = select.value;
      });
      return values;
    }

    function findVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var options = [v.option1, v.option2, v.option3];
        var matches = true;
        for (var j = 0; j < values.length; j++) {
          if (values[j] !== undefined && options[j] !== values[j]) {
            matches = false;
            break;
          }
        }
        if (matches) return v;
      }
      return null;
    }

    function updateUI(variant) {
      var priceEl = document.getElementById('ProductPrice');
      var addBtn = document.getElementById('ProductAddToCart');
      var addText = document.getElementById('ProductAddToCartText');
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        return;
      }
      variantInput.value = variant.id;
      if (priceEl && typeof variant.price === 'number') {
        priceEl.textContent = formatMoney(priceEl, variant.price);
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }

    // Reuses the shop's own money format: the server-rendered price already
    // carries the correct currency symbol/position, so on first run we cache
    // that pattern (e.g. "₹1,234.00") and substitute the new amount into it
    // rather than guessing a symbol.
    function formatMoney(priceEl, cents) {
      var amount = (cents / 100).toFixed(2);
      if (!priceEl.getAttribute('data-money-template')) {
        var sample = priceEl.textContent.trim();
        var template = sample.replace(/[0-9][0-9.,]*/, '{{amount}}');
        priceEl.setAttribute('data-money-template', template);
      }
      var withThousands = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return priceEl.getAttribute('data-money-template').replace('{{amount}}', withThousands);
    }

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        var variant = findVariant(currentSelection());
        updateUI(variant);
      });
    });
  }
})();
